import { render, staticRenderFns } from "./PayV2Loading.vue?vue&type=template&id=2e60b648&scoped=true"
import script from "./PayV2Loading.vue?vue&type=script&lang=js"
export * from "./PayV2Loading.vue?vue&type=script&lang=js"
import style0 from "./PayV2Loading.vue?vue&type=style&index=0&id=2e60b648&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e60b648",
  null
  
)

export default component.exports